import React, { useEffect, useState } from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { LoginForm } from '.';
import { IUserLoginFormResponse } from '@gik/api/users/auth';
import { IUserLoginFormValues } from './LoginForm';
import { Button } from '@gik/ui';
import OAuthErrorModalContent from '@gik/auth/components/Login/OAuthErrorModalContent';
import ExternalLoginForm from '@gik/auth/components/ExternalLogin/ExternalLoginForm';

const blockName = 'login-form-section';

export interface ILoginFormSectionProps {
  buttonsPortal?: () => HTMLElement;
  onSuccess?: (doneResponse: IUserLoginFormResponse, values: IUserLoginFormValues) => void | Promise<void>;
  onForgotPassword?: () => void | Promise<void>;
  onSignup?: () => void | Promise<void>;
  oauthErrorMessage?: string;
}

export default function LoginFormSection({
  buttonsPortal,
  onSuccess,
  onForgotPassword,
  onSignup,
  oauthErrorMessage: initialOauthErrorMessage,
}: ILoginFormSectionProps) {
  const [oauthErrorMessage, setErrorMessage] = useState<string>();

  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  // TODO: GIK-2477 show error message with the option that matches the correct provider
  const errorMessageButtons = (
    <>
      <Button block onClick={() => setErrorMessage(undefined)}>
        Try again
      </Button>
    </>
  );
  // FIXME: I had to do this to trigger a re-render, as buttonsPortal() returns undefined on first render
  useEffect(() => {
    setErrorMessage(initialOauthErrorMessage);
  }, [initialOauthErrorMessage]);

  return (
    <section className={bem()}>
      <OAuthErrorModalContent
        errorMessageButtons={errorMessageButtons}
        oauthErrorMessage={oauthErrorMessage}
        buttonsPortal={buttonsPortal}
      />
      {!oauthErrorMessage && (
        <>
          <ExternalLoginForm />
          <div className={bem('title')}>{t(translationKeys.formTitle)}</div>
          <LoginForm
            buttonsPortal={buttonsPortal}
            onSuccess={onSuccess}
            onForgotPassword={onForgotPassword}
            onSignup={onSignup}
          />
        </>
      )}
    </section>
  );
}
